export const ACCOUNT_TAB = 'account' as const;
export const ADS_TAB = 'ads' as const;

export type TransactionTabType = typeof ACCOUNT_TAB | typeof ADS_TAB;

export const DEFAULT_PAGE_SIZE = 15;

export const INCOME_SERVICE_NAMES = new Set(['Пополнение счета']);
